import { gql } from "@apollo/client"

const GET_USER = gql`
  query AppCtxUser($staff_id: ID!, $organization_id: ID) {
    user(staff_id: $staff_id, organization_id: $organization_id) {
      staff_id
      staff_alias
      staff_user_status
      staff_name_first
      staff_name_last
      staff_role
      staff_role_name
      staff_description
      staff_group_type
      staff_email_address
      staff_create_date
      staff_membership_id
      environment
      enterprise_id
      enterprise_alias
      enterprise_id_stamp
      enterprise_name
      enterprise_type
      organization_id
      organization_alias
      organization_id_stamp
      organization_name
      organization_type
    }
  }
`
const GET_PARTICIPANT = gql`
  query AppCtxParticipant($participant_id: ID!, $organization_id: ID!) {
    participant(
      participant_id: $participant_id
      organization_id: $organization_id
    ) {
      participant_id
      participant_alias
      participant_membership_id
      participant_name_first
      participant_name_last
      participant_name_preferred
      participant_phone_primary
      participant_email_account
      participant_city_primary
      participant_state_primary
      participant_zip_code_primary
      participant_external_id
      participant_profile_image
      participant_membership_status
      program_list
      participant_last_engagement
      participant_last_activity
      organization_id
      staff_full_name
      locations
    }
  }
`

const GET_PARTICIPANT_BY_ALIAS_ID = gql`
  query Participant(
    $participant_alias: String
    $staff_id: ID!
    $organization_id: ID!
  ) {
    participantAdvancedSearch(
      participant_alias: $participant_alias
      staff_id: $staff_id
      organization_id: $organization_id
    ) {
      participant_id
      participant_alias
      participant_membership_id
      participant_name_first
      participant_name_last
      participant_name_preferred
      participant_phone_primary
      participant_email_account
      participant_city_primary
      participant_state_primary
      participant_zip_code_primary
      participant_membership_status
      organization_id
    }
  }
`

/* Set participant by phone */
const GET_PARTICIPANT_BY_PHONE = gql`
  query participantByNumber($phone: String!) {
    participantByNumber(phone: $phone) {
      participant_id
      participant_alias
    }
  }
`

const GET_MICROSERVICE_TOKENS = gql`
  {
    telerecovery: token(microservice_id: 1) {
      jwt
    }
    appointments: token(microservice_id: 2) {
      jwt
    }
    notifications: token(microservice_id: 4) {
      jwt
    }
    tasks: token(microservice_id: 5) {
      jwt
    }
    assessments: token(microservice_id: 6) {
      jwt
    }
    housing: token(microservice_id: 7) {
      jwt
    }
    documentSign: token(microservice_id: 8) {
      jwt
    }
    gpra: token(microservice_id: 9) {
      jwt
    }
    kiosk: token(microservice_id: 10) {
      jwt
    }
    employment: token(microservice_id: 11) {
      jwt
    }
    coordtionationBoards: token(microservice_id: 14) {
      jwt
    }
    googlePlaces: getSecretValue(secret_name:"google_places_api_key"){
      data
    }
    mapBox: getSecretValue(secret_name:"mapbox_access_token"){
      data
    }
  }
`

export {
  GET_USER,
  GET_PARTICIPANT,
  GET_PARTICIPANT_BY_ALIAS_ID,
  GET_PARTICIPANT_BY_PHONE,
  GET_MICROSERVICE_TOKENS,
}
